import React, { Fragment, useContext, useEffect } from 'react'
import { Typography, Grid, Divider, Fade } from '@mui/material'

import { useStyles } from '../styles'
import {
  Configuration,
  TypeConfiguration
} from '../../../interfaces/Configuration/Configuration'
import { ConfigurationContext } from '../configurationContext'
import { useTypeConfiguration } from '../../../hooks/useTypeConfiguration'
import { InputConfiguration } from '../InputConfiguration/InputConfiguration'

interface ParametersProps {}

export const Parameters: React.FC<ParametersProps> = () => {
  const classes = useStyles()
  const { state, handleChange } = useContext(ConfigurationContext)
  const { parameters } = state

  const {
    typeConfigurationState: { typeConfiguration },
    getTypeConfiguration
  } = useTypeConfiguration()

  useEffect(() => {
    getTypeConfiguration()
  }, [])

  return (
    <Fade in={true}>
      <Grid container spacing={4} direction='row' alignItems='center'>
        {typeConfiguration.length > 0 &&
          parameters.length > 0 &&
          typeConfiguration.map((t: TypeConfiguration) => {
            const params = parameters.filter(
              (p: Configuration) =>
                p.typeConfigurationId === t.typeConfigurationId
            )

            if (params) {
              return (
                <Fragment>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography
                      gutterBottom
                      variant='h6'
                      className={classes.titleText}
                    >
                      {t.name}
                    </Typography>
                    <Divider variant='middle' />
                  </Grid>

                  {params.map((i: Configuration) => {
                    return (
                      <InputConfiguration
                        typeValue={i.type}
                        id={`${i.name}`}
                        name={`${i.name}`}
                        value={`${i.value}`}
                        label={`${i.label}`}
                        placeholder={`${i.placeHolder}`}
                        toolTipText={`${i.description}`}
                        typeConfigurationId={i.typeConfigurationId}
                        onChange={handleChange}
                      />
                    )
                  })}
                </Fragment>
              )
            }
            return ''
          })}
      </Grid>
    </Fade>
  )
}
